<template>
    <b-container fluid>
        <iq-card>
            <template v-slot:headerTitle>
                <h4 class="card-title">{{ $t('production_store.raw_material1') }}</h4>
            </template>
            <template v-slot:body>
                <b-row>
                    <b-col xs="12" sm="12" md="5">
                        <b-form-group
                        class="row"
                        label-cols-sm="3"
                        label-for="requisition_id"
                        >
                        <template v-slot:label>
                            {{ $t('production_store.requisition_id')}}
                        </template>
                        <b-form-input
                            id="requisition_id"
                            v-model="search.requisition_id"
                            placeholder=""
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col xs="12" sm="12" md="5">
                    <ValidationProvider name="Requisition Date" vid="requisition_date" rules="required">
                        <b-form-group
                            class="row"
                            label-cols-sm="3"
                            label-for="requisition_date"
                            slot-scope="{ valid, errors }"
                        >
                            <template v-slot:label>
                                {{$t('production_store.requisition_date')}}
                            </template>
                            <b-form-input class="form-control"
                                v-model="search.requisition_date"
                                placeholder="Select Date"
                                id="requisition_date"
                                :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-input>
                            <div class="invalid-feedback">
                            {{ errors[0] }}
                            </div>
                        </b-form-group>
                    </ValidationProvider>
                    </b-col>
                    <b-col sm="12" md="2">
                        <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search')}}</b-button>
                    </b-col>
                </b-row>
            </template>
        </iq-card>
        <b-row>
            <b-col md="12">
                <iq-card>
                    <template v-slot:headerTitle>
                        <h4 class="card-title">{{ $t('production_store.raw_material') + ' ' + $t('globalTrans.list') }}</h4>
                    </template>
                    <template v-slot:headerAction>
                        <b-button variant="primary" v-b-modal.modal-4 @click="addForm">
                            <i class="fas fa-plus"></i>{{ $t('globalTrans.add_new') }}
                        </b-button>
                    </template>
                    <template v-slot:body>
                        <b-overlay :show="loadingState">
                            <b-row>
                                <b-col md="12" class="table-responsive">
                                    <b-table thead-class="bg-primary" :emptyText="$t('globalTrans.noDataFound')" show-empty bordered hover :items="listData" :fields="columns" aria-hidden="loading | listReload ? 'true' : null">
                                        <template v-slot:cell(index)="data">
                                            {{ $n(data.index + pagination.slOffset) }}
                                        </template>
                                        <template v-slot:cell(requisition_date)="data">
                                            <span class="capitalize">{{ data.item.requisition_date | dateFormat }}</span>
                                        </template>
                                        <template v-slot:cell(usable_area)="data">
                                            <span class="capitalize">{{ data.item.usable_area }}</span>
                                        </template>
                                        <template v-slot:cell(status)="data">
                                            <span class="badge badge-warning" v-if="data.item.status == 1">
                                                {{$t('globalTrans.pending')}}
                                                <span v-if="data.item.req_id !== null">
                                                By {{ getNameReceiver(data.item.receiver_id) }}
                                                </span>
                                            </span>
                                            <span class="badge badge-success" v-else-if="data.item.status == 2">{{$t('globalTrans.approved')}}</span>
                                            <span class="badge badge-danger" v-else>{{$t('globalTrans.rejected')}}</span>
                                        </template>
                                        <template v-slot:cell(action)="data">
                                            <router-link class="btn_table_action btn_green" v-b-modal.modal-1 :title="$t('globalTrans.details')" :to="'/production-service/store-management/raw-material-requisition-entry?id='+data.item.id+'&&view='+data.item.id"><i class="fas fa-eye"></i></router-link>
                                            <span v-if="data.item.req_id === null">
                                                <router-link :to="'/production-service/store-management/raw-material-requisition-entry?id='+data.item.id" class="iq-bg-success mr-1 mb-1" size="sm" :title="$t('globalTrans.edit')"><i class="ri-ball-pen-fill m-0"></i></router-link>
                                                <a href="javascript:" v-b-modal.modal-2 class="btn_table_action btn_blue" @click="forward(data.item)" :title="$t('globalTrans.forward')"><i class="fas fa-forward"></i></a>
                                            </span>
                                        </template>
                                    </b-table>
                                    <b-pagination
                                        v-model="pagination.currentPage"
                                        :per-page="pagination.perPage"
                                        :total-rows="pagination.totalRows"
                                        @input="searchData"
                                        />
                                </b-col>
                            </b-row>
                        </b-overlay>
                    </template>
                </iq-card>
            </b-col>
        </b-row>
        <b-modal id="modal-2" size="lg" :title="$t('production_store.forward')" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
            <p>
                <FormForward :id="forwardItemId" />
            </p>
        </b-modal>
    </b-container>
</template>
<script>
import FormForward from './Forward'
import RestApi, { productionServiceBaseUrl } from '@/config/api_config'
import { materialRequisitionListApi } from '../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'
import flatpickr from 'flatpickr'

export default {
  mixins: [ModalBaseMasterList],
  components: {
    FormForward
  },
  data () {
    return {
        search: {
            requisition_id: '',
            requisition_date: ''
        },
        forwardItemId: '',
        rows: [],
        userList: [],
        receiverId: 0
    }
  },
  computed: {
    columns () {
      const labels = [
            { label: this.$t('globalTrans.sl_no'), class: 'text-left' },
            { label: this.$t('production_store.requisition_date'), class: 'text-left' },
            { label: this.$t('production_store.requisition_id'), class: 'text-left' },
            { label: this.$t('production_store.useable_area'), class: 'text-left' },
            { label: this.$t('globalTrans.status'), class: 'text-center' },
            { label: this.$t('globalTrans.action'), class: 'text-center' }
        ]

        let keys = []

        if (this.$i18n.locale === 'bn') {
            keys = [
                { key: 'index' },
                { key: 'requisition_date' },
                { key: 'requisition_id' },
                { key: 'usable_area_bn' },
                { key: 'status' },
                { key: 'action' }
            ]
        } else {
            keys = [
                { key: 'index' },
                { key: 'requisition_date' },
                { key: 'requisition_id' },
                { key: 'usable_area' },
                { key: 'status' },
                { key: 'action' }
            ]
        }

        return labels.map((item, index) => {
          return Object.assign(item, keys[index])
        })
    },
    currentLocale: function () {
        return this.$i18n.locale
    }
  },
  watch: {
  },
  created () {
    this.loadData()
  },
  mounted () {
        flatpickr('#requisition_date', {})
  },
  methods: {
    forward (item) {
        this.forwardItemId = item.id
    },
    searchData () {
      this.loadData()
    },
    addForm () {
      this.$router.push({ path: '/production-service/store-management/raw-material-requisition-entry' })
    },
    loadData () {
      const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.getData(productionServiceBaseUrl, materialRequisitionListApi, params).then(response => {
        if (response.success) {
            this.userList = response.userDetails
            this.$store.dispatch('setList', this.getRelationalData(response.data.data))
            this.paginationData(response.data)
        }
        this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      })
    },
    getRelationalData (data) {
        const listData = data.map(item => {
            const evaluationData = {
                requisition_id: item.requisition_id !== undefined ? item.requisition_id : '',
                requisition_date: item.requisition_date !== undefined ? item.requisition_date : '',
                usable_area: item.usable_area_bn !== undefined ? item.usable_area : '',
                usable_area_bn: item.usable_area !== undefined ? item.usable_area_bn : ''
            }

            return Object.assign({}, item, evaluationData)
        })
        return listData
    },
    getNameReceiver (id) {
      const userName = this.userList.find(user => user.value === id)
      if (this.$i18n.locale === 'bn') {
        return userName.text_bn
      } else {
        return userName.text_en
      }
    }
  }
}
</script>
